export default {
  common: {
    settings: '/api/settings',
    settingsTitles: '/api/settings-titles',
    teachers: '/api/study-center/day-lessons',
    teachers1: '/api/teachers',
    teacherId: '/api/teachers/{teacher}',
    statuses: '/api/statuses',
    classLevels: '/api/class-levels',
    groups: '/api/groups',
    groupId: '/api/groups/{group}',
    classes: '/api/classes',
    classId: '/api/classes/{class}',
    onlyWorkers: '/api/only-workers',
    campuses: '/api/campuses-all',
    maintenancePriorities: '/api/maintenance-priorities',
    exitPlaces: '/api/exit-places',
    timeSlotBreakMessages: '/api/time-slot-break-messages',
    usersInCampusId: '/api/users/in-campus/{campus}',
    workersInCampusId: '/api/users/workers-in-campus/{campus}'
  },

  studentList: {
    studentDashboard: '/api/report-statistic',
    studentDashboardDetail: '/api/reports',
    students: '/api/students',
    newStudentsList: 'api/student-list',
    usersStudents: '/api/users-students',
    studentId: '/api/students/{student}',
    campusGroups: '/api/campus-groups',
    campusGroupId: '/api/campus-groups/{group}',
    campusClasses: '/api/campus-classes',
    campusClassId: '/api/campus-classes/{class}',
    groupsInCampus: '/api/groups-in-campus',
    classesInCampus: '/api/classes-in-campus',
    campusesToStudentFilter: '/api/campuses-to-student-filter',
    classLevelUp: '/api/students/class-level-up',
    studentsWithoutGroup: '/api/students-without-group',
    studentsWithoutClass: '/api/students-without-class',
    groupIdTeacherId: '/api/groups/{group}/teachers/{teacher}',
    classIdTeacherId: '/api/classes/{class}/teachers/{teacher}',
    column: '/api/students-boards/{board}/columns',
    columnId: '/api/students-boards/{board}/columns/{column}',
    columnManagerId:
      '/api/students-boards/{board}/columns/{column}/managers/{manager}',
    studentIdGroupId: '/api/students/{student}/group/{group}',
    studentIdClassId: '/api/students/{student}/class/{class}',
    attachStudentToColumn:
      '/api/students-boards/{board}/columns/{column}/members/{student}/attach',
    detachStudentToColumn:
      '/api/students-boards/{board}/columns/{column}/members/{student}/detach',
    studentsBoards: '/api/students-boards',
    studentsBoardId: '/api/students-boards/{board}'
  },
  studentBehavior: {
    exitPermissions: '/api/exit-permissions',
    exitPermissionId: '/api/exit-permissions/{exitPermission}',
    userExitPermissions: '/api/exit-permissions/users/{user}',
    studentExitPermissions: '/api/exit-permissions/students/{student}',
    userAttendance: '/api/student-get-attendance-from-report?user_id=',
    studyCenterAttendance:
      '/api/student-get-attendance-from-study-center?user_id=',
    studeCenters: '/api/study-center/categories?campus_id=1'
  },
  reports: {
    reports: '/api/reports',
    reportId: '/api/reports/{report}',
    reportRequests: '/api/report-requests',
    reportRequestId: '/api/report-requests/{report}',
    reportReasons: '/api/report-reasons',
    reportFilters: '/api/report-statistic-filters',
    reportExcel: '/api/report-download-excel'
  },
  serviceOrders: {
    choice: '/api/service-orders/{serviceOrder}/choice',
    filters: '/api/service-orders-filters'
  },
  studyCenter: {
    timeSlotTemplates: '/api/study-center/time-slot-templates',
    timeSlotTemplateId: '/api/study-center/time-slot-templates/{template}',
    timeSlots: '/api/study-center/time-slots',
    timeSlotId: '/api/study-center/time-slots/{timeSlot}',
    timeSlotTypes: '/api/study-center/time-slot-types',
    lessonSubjects: '/api/study-center/lesson-subjects',
    lessonTypes: '/api/study-center/lesson-types',
    scheduleLessons: '/api/study-center/schedule-lessons',
    scheduleLessonId: '/api/study-center/schedule-lessons/{lesson}',
    lessons: '/api/study-center/lessons',
    dayLessons: '/api/study-center/day-lessons',
    lessonId: '/api/study-center/lessons/{lesson}',
    lessonUserStatuses: '/api/study-center/lesson-user-statuses',
    monthLessonsCount: '/api/study-center/month-count-lessons',
    exceptionDays: '/api/study-center/exception-days',
    exceptionDayId: '/api/study-center/exception-days/{day}',
    calendarEvents: '/api/study-center/calendar-events',
    teacherSkills: '/api/study-center/teacher-skills',
    classLevels: '/api/study-center/class-levels',
    requestToLesson: '/api/study-center/lesson-requests',
    declineLessons: '/api/study-center/decline-lessons',
    requestToLessonAccept: '/api/study-center/lesson-requests/{request}/accept',
    requestToLessonDecline:
      '/api/study-center/lesson-requests/{request}/decline',
    blockTemplates: '/api/study-center/lessons/block-templates-from-this-date',
    unblockTemplates:
      '/api/study-center/lessons/{lesson}/unblock-lesson-schedule',
    deleteStudentForever:
      '/api/study-center/schedule-lesson/{scheduleLessonId}/remove-student-from-this-date/{studentId}',
    reproachesSchedule: '/api/get-student-lessons',
    reproachesScheduleAllStudent: '/api/get-multiple-students-lessons',
    reproachesScheduleAllStudentNew:
      '/api/main-info/combined-schedule/get-meetings'
  },
  administrationResours: {
    distric_administrations_by_slug:
      '/api/main-info/get-dis-adm-dictionary-by-slug',
    institution_dictionary_by_slug:
      '/api/main-info/get-institution-dictionary-by-slug',
    distric_administrations: '/api/main-info/district-administration',
    owners: '/api/main-info/institution-dict/owners',
    institutions: '/api/main-info/institutions',
    sectors: '/api/main-info/district-administration-dict/sector',
    ministry:
      '/api/main-info/district-administration-dict/district-of-ministry-education',
    departaments:
      '/api/main-info/district-administration-dict/department-of-interior-district',
    education_types: '/api/main-info/institution-dict/education-types',
    regions: '/api/main-info/institution-dict/regions',
    types: '/api/main-info/institution-dict/types',
    education_stages: '/api/main-info/institution-dict/education-stages',
    legal_statuses: '/api/main-info/institution-dict/legal-statuses',
    InstitutSector: '/api/main-info/institution-dict/sectors',
    gender_types: '/api/main-info/institution-dict/gender-types',
    supervision: '/api/main-info/institution-dict/supervision'
  },
  security: {
    permits: '/api/security/permits/',
    users: '/api/security-users/'
  },
  chat: {
    chats: '/api/chats',
    chatsUsers: '/api/users/in-campus/{campus}/with-without-campus'
  }
};
